export default __webpack_public_path__ + "static/media/2.d33c55e2.png";